/**
 * Ant Design Form validation rules for the Feedback survey form.
 * Use with Form.Item rules prop, e.g. rules={feedbackValidationRules.email}
 */

const rangeValidator = (min, max, message) => () => ({
  validator(_, value) {
    if (value == null) return Promise.reject(new Error(message));
    const n = Number(value);
    if (n >= min && n <= max) return Promise.resolve();
    return Promise.reject(new Error(message));
  },
});

export const feedbackValidationRules = {
  email: [
    { required: true, message: "Please enter your email" },
    { type: "email", message: "Please enter a valid email" },
  ],
  orderNumber: [
    { pattern: /^\d*$/, message: "Order id must contain only numbers" },
  ],
  recommendationRating: [
    rangeValidator(
      0,
      10,
      "Please select a rating from 0 to 10"
    ),
  ],
  statusUpdatesRating: [
    rangeValidator(
      1,
      5,
      "Please select a rating from 1 to 5"
    ),
  ],
  turnaroundTimeRating: [
    rangeValidator(
      1,
      5,
      "Please select a rating from 1 to 5"
    ),
  ],
  complianceRating: [
    rangeValidator(
      1,
      5,
      "Please select a rating from 1 to 5"
    ),
  ],
  accuracyRating: [
    rangeValidator(
      1,
      5,
      "Please select a rating from 1 to 5"
    ),
  ],
  additionalComments: [
    { required: true, message: "Please provide your feedback" },
    { whitespace: true, message: "Please provide your feedback" },
  ],
  contactRepresentative: [
    { required: true, message: "Please select Yes or No" },
  ],
  suitableDateFrom: [
    { required: true, message: "Please select From Date" },
  ],
  suitableDateTo: [
    { required: true, message: "Please select To Date" },
  ],
  suitableTime: [
    { required: true, message: "Please enter suitable time" },
  ],
};

export default feedbackValidationRules;
